// import axios from "axios"
import axios from "../../constants/axios"
import endpoints from "../../constants/endpoints"

export const SEARCH_DATA = async (
  filterData,
  setData,
  setMeta,
  currentPage,
  setSearchLoading
) => {
  filterData = filterData
    ? filterData + `&page=${currentPage + 1}`
    : `?page=${currentPage + 1}`
  try {
    const res = await axios.get(
      process.env.GATSBY_BASE_URL + endpoints.CANDIDATE_SEARCH + filterData
    )
    if (res.status === 200) {
      setMeta(res.data)
      setData(res.data.results)
      setSearchLoading(false)
    }
  } catch (err) {
    setData([])
    setMeta({})
    setSearchLoading(false)
  }
}

export const GET_RECOMMENDATIONS = async (filterData, setData) => {
  try {
    const res = await axios.get(
      process.env.GATSBY_BASE_URL +
        endpoints.CANDIDATE_RECOMMENDATION +
        filterData
    )
    setData(res.data.recommended)
  } catch (err) {
    if (err.response && err.response.status === 404) {
      setData([])
    }
    setData([])
  }
}

export const SAVE_SEARCH_RESULTS = async (
  data,
  setMessage,
  search,
  setSerch,
  setShowModal
) => {
  try {
    const res = await axios.post(
      process.env.GATSBY_BASE_URL + endpoints.CANDIDATE_SEARCH_HISTORY,
      data
    )
    if (res.status === 201) {
      setMessage("Successfully saved search results.")
      const { data } = res
      setSerch([...search, data])
      setShowModal(0)
      setTimeout(() => {
        setMessage("")
      }, 2000)
    }
  } catch (err) {
    setMessage("Something went wrong please try again")
    if (err.response && err.response.status === 404) {
    }
  }
}

export const FETCH_SEARCH_HISTORY = async setSavedSearch => {
  try {
    const res = await axios.get(
      process.env.GATSBY_BASE_URL + endpoints.CANDIDATE_SEARCH_HISTORY
    )
    if (res.status === 200) {
      setSavedSearch(res.data)
    }
  } catch (err) {}
}

export const DELETE_SEARCH_HISTORY = async (
  id,
  setShowModal,
  value,
  setSavedSearch,
  savedSearch
) => {
  try {
    const res = await axios.delete(
      process.env.GATSBY_BASE_URL + endpoints.CANDIDATE_SEARCH_HISTORY + id
    )
    if (res.status === 204) {
      const remainingHistory = savedSearch.filter(search => search.id !== id)
      setSavedSearch(remainingHistory)
      setShowModal(value)
    }
  } catch (err) {}
}
